/** All operand types (used for right side when left is key or other). */
export const OPERAND_TYPES = [
    { value: "literal", label: "Literal value" },
    { value: "answer", label: "Answer (question/answer set)" },
    { value: "derivedAttribute", label: "Derived attribute" },
    { value: "key", label: "Key (context path)" },
    { value: "workItemAttribute", label: "Work item attribute" },
] as const;

/** Left side only: Answer, Derived attribute, Key (no Literal, no Work item attribute). */
export const OPERAND_TYPES_LEFT = [
    { value: "answer", label: "Answer (question/answer set)" },
    { value: "derivedAttribute", label: "Derived attribute" },
    { value: "key", label: "Key (context path)" },
] as const;

export const CODES_CONTEXT_KEYS = ["code", "codeType", "sequenceNumber"] as const;
export const WORK_ITEM_ATTRIBUTE_NAMES = ["patientClass", "visitReason", "serviceLine"] as const;
export const CASE_CONTEXT_KEYS = [...WORK_ITEM_ATTRIBUTE_NAMES] as const;
export const SPAN_CONTEXT_KEYS = ["text", "start", "end"] as const;

export const OTHER_KEY = "__other__";

export function parseLiteral(input: string): unknown {
    const trimmed = input.trim();
    if (trimmed.toLowerCase() === "true") return true;
    if (trimmed.toLowerCase() === "false") return false;
    const n = Number(trimmed);
    if (trimmed !== "" && !Number.isNaN(n)) return n;
    return trimmed;
}

export function formatLiteral(value: unknown): string {
    if (value === null || value === undefined) return "";
    if (typeof value === "boolean") return value ? "true" : "false";
    if (typeof value === "number") return String(value);
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
}

export function toNum(v: unknown): number | undefined {
    if (v == null || v === "") return undefined;
    const n = Number(v);
    return Number.isFinite(n) ? n : undefined;
}
